export default __webpack_public_path__ + "static/media/IEEE-vjti.a7615f1f.png";